import React, { useMemo } from "react";
import { Dialog } from "@mui/material";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { ReactComponent as UserIcon } from "assets/img/svg/userProfile.svg";
import CustomCopyToClipboard from "views/pages/manage/common/ACopyToClipboard/CustomCopyToClipboard";


const safeTrim = (value) => (value ? value.toString().trim() : "");

const ContactRow = ({ label, value }) => {
  const trimmedValue = safeTrim(value);

  return (
    <div className="d-flex align-items-center">
      <div className="regular-bolder me-2">{label} :</div>
      <div>{trimmedValue || "-"}</div>

      {trimmedValue && (
        <div className="ms-auto">
          <CustomCopyToClipboard textToCopy={trimmedValue} />
        </div>
      )}
    </div>
  );
};

const ContactSection = ({ title, name, mobile, email }) => (
  <div className="d-flex justify-content-start px-3 py-2" style={{ gap: 20 }}>
    <UserIcon />

    <div className="d-flex flex-column flex-grow-1" style={{ gap: 6 }}>
      <span className="regular-large-bold">{title || name}</span>

      {mobile !== undefined && (
        <ContactRow label="Mobile number" value={mobile} />
      )}

      {email !== undefined && (
        <ContactRow label="Email" value={email} />
      )}
    </div>
  </div>
);

const ContactDetailDialog = ({ open, handleClose, contactDetails }) => {
  const {
    studentName,
    studentMobile,
    studentEmail,
    parentMobile,
    parentEmail,
  } = useMemo(() => {
    const firstName = safeTrim(contactDetails?.studentFirstName);
    const lastName = safeTrim(contactDetails?.studentLastName);

    return {
      studentName: `${firstName} ${lastName}`.trim(),
      studentMobile: safeTrim(contactDetails?.studentMobileNumber),
      studentEmail: safeTrim(contactDetails?.studentEmailId),
      parentMobile:
        safeTrim(contactDetails?.studentFathersMobileNumber) ||
        safeTrim(contactDetails?.mothersMobileNumber),
      parentEmail:
        safeTrim(contactDetails?.fathersEmailId) ||
        safeTrim(contactDetails?.mothersEmailId),
    };
  }, [contactDetails]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      
      <div className="d-flex justify-content-between align-items-center px-3 py-2">
        <span className="heading-4">Contact Details</span>
        <IconButtonWrapper onClick={handleClose}>
          <CrossIcon />
        </IconButtonWrapper>
      </div>

      <ContactSection
        name={studentName}
        mobile={studentMobile}
        email={studentEmail}
      />

      
      <ContactSection
        title="Parent"
        mobile={parentMobile}
        email={parentEmail}
      />
    </Dialog>
  );
};

export default ContactDetailDialog;